"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletErrors = exports.WalletError = exports.WalletErrorCode = void 0;
var WalletErrorCode;
(function (WalletErrorCode) {
    // shell
    WalletErrorCode[WalletErrorCode["UNSUPPORTED_WALLET"] = 0] = "UNSUPPORTED_WALLET";
    WalletErrorCode[WalletErrorCode["NOT_INSTALLED_WALLET"] = 1] = "NOT_INSTALLED_WALLET";
    WalletErrorCode[WalletErrorCode["NOT_INJECTED_WALLET"] = 2] = "NOT_INJECTED_WALLET";
    WalletErrorCode[WalletErrorCode["NOT_CONNECTED_WALLET"] = 3] = "NOT_CONNECTED_WALLET";
    WalletErrorCode[WalletErrorCode["UNSUPPORTED_METHOD"] = 4] = "UNSUPPORTED_METHOD";
    // API interaction
    WalletErrorCode[WalletErrorCode["API_CALL_FAILED"] = 5] = "API_CALL_FAILED";
    // user
    WalletErrorCode[WalletErrorCode["COLLATERAL_IS_MISSING"] = 6] = "COLLATERAL_IS_MISSING";
    // transaction
    WalletErrorCode[WalletErrorCode["TRANSACTION_BUILDING_FAILED"] = 7] = "TRANSACTION_BUILDING_FAILED";
    // other
    WalletErrorCode[WalletErrorCode["UNKNOWN"] = 8] = "UNKNOWN";
})(WalletErrorCode || (exports.WalletErrorCode = WalletErrorCode = {}));
var WalletError = /** @class */ (function (_super) {
    __extends(WalletError, _super);
    function WalletError(code, message) {
        var _this = _super.call(this, message) || this;
        _this.name = "Wallet error";
        _this.code = code;
        return _this;
    }
    return WalletError;
}(Error));
exports.WalletError = WalletError;
exports.WalletErrors = (_a = {},
    // shell
    _a[WalletErrorCode.UNSUPPORTED_WALLET] = function (name) { return new WalletError(WalletErrorCode.UNSUPPORTED_WALLET, name + " is unsupported"); },
    _a[WalletErrorCode.NOT_INSTALLED_WALLET] = function (name) { return new WalletError(WalletErrorCode.NOT_INSTALLED_WALLET, name + " isn't installed"); },
    _a[WalletErrorCode.NOT_CONNECTED_WALLET] = new WalletError(WalletErrorCode.NOT_CONNECTED_WALLET, "wallet isn't connected"),
    _a[WalletErrorCode.UNSUPPORTED_METHOD] = function (name, method) { return new WalletError(WalletErrorCode.UNSUPPORTED_METHOD, name + " doesn't support " + method); },
    // API call
    _a[WalletErrorCode.API_CALL_FAILED] = function (cause) { return new WalletError(WalletErrorCode.API_CALL_FAILED, cause); },
    // user
    // Cardano
    _a[WalletErrorCode.COLLATERAL_IS_MISSING] = new WalletError(WalletErrorCode.COLLATERAL_IS_MISSING, "collateral of wallet is missing"),
    // transaction
    _a[WalletErrorCode.TRANSACTION_BUILDING_FAILED] = function (cause) { return new WalletError(WalletErrorCode.TRANSACTION_BUILDING_FAILED, cause); },
    // other
    _a[WalletErrorCode.UNKNOWN] = function (cause) { return new WalletError(WalletErrorCode.UNKNOWN, cause); },
    _a);
